import React from "react";

export function getBenchmarkName(nameIn, currency) {
  var ret = nameIn;
  if (currency === "CAD") {
    switch (nameIn) {
      case "clientSpecified":
        ret = "Client Specified Benchmark";
        break;
      case "cdnStocks":
        ret = "CDN Stocks";
        break;
      case "usStocksUnhedged":
        ret = "US Stocks (Unhedged)";
        break;
      case "cdnLongGovtBonds":
        ret = "CDN 10-year Gov't Bonds";
        break;
      case "cdnCash":
        ret = "CDN Cash";
        break;
      case "worldDeveloped":
        ret = "World Developed Markets Stocks (ex-US) FTSE (unhedged)";
        break;
      case "goldETF":
        ret = "Gold ETF";
        break;
      case "balancedCdnUnhedgedUsEquity":
        ret = "Balanced CDN & Unhedged US Equity";
        break;
      case "balancedCdnEquityAndCdnGovtBonds":
        ret = "Balanced CDN Stocks & CDN Gov't Bonds";
        break;
      case "balancedCdnEquityAndCdnGovtBondsPlusCash":
        ret = "Balanced CDN Stocks & CDN Gov't Bonds Plus Cash";
        break;
      case "balancedCdnAndUsEquityAndCdnGovtBonds":
        ret = "Balanced CDN & US Stocks and CDN Gov't Bonds Plus Cash";
        break;
      case "equalWeight":
        ret = "Equal Weight CDN & US Stocks, Bond, & Cash, Not Rebalanced";
        break;
      default:
        break;
    }
  } else if (currency === "USD") {
    switch (nameIn) {
      case "clientSpecified":
        ret = "Client Specified Benchmark";
        break;

      case "cdnStocks":
        ret = "US Stocks";
        break;
      case "usStocksUnhedged":
        ret = "World Developed Markets Stocks (ex-US) FTSE";
        break;
      case "cdnLongGovtBonds":
        ret = "US 10-year Treasury Bonds";
        break;
      case "cdnCash":
        ret = "US Treasury Bills (1-mo) Cash";
        break;
      case "goldETF":
        ret = "Gold ETF";
        break;
      case "balancedCdnUnhedgedUsEquity":
        ret = "Balanced US & Unhedged FTSE Developed Markets Stocks (ex US)";
        break;
      case "balancedCdnEquityAndCdnGovtBonds":
        ret = "Balanced US Stocks & US Treasury Bonds";
        break;
      case "balancedCdnEquityAndCdnGovtBondsPlusCash":
        ret = "Balanced US Stocks & US Treasury Bonds Plus Cash";
        break;
      case "balancedCdnAndUsEquityAndCdnGovtBonds":
        ret = "Balanced US & FTSE Stocks, US Treasury Bonds, & Cash";
        break;
      case "equalWeight":
        ret = "Equal Weight US Stocks, FTSE, Bond, & Cash, Not Rebalanced";
        break;
      default:
        break;
    }
  }

  return ret;
}

export const getBenchmarkColumnName = (key, currency) => {
  const builder = [
    { type: "mainIndex", heading: "S&P/TSX Composite", heading2: "S&P 500" },
    {
      type: "secondaryIndex",
      heading: "S&P500 Unhedged",
      heading2: "Vanguard FTSE World Markets ETF (ex US)",
    },
    {
      type: "tenYearBond",
      heading: "CDN 10-year Gov’t Bonds",
      heading2: "US Treasury Bonds<br/>(10-year)",
    },
    {
      type: "oneMonthTbill",
      heading: "CDN Tbills (30 day)",
      heading2: "US Treasury Bills<br/>(1-month)",
    },
    {
      type: "worldDeveloped",
      heading: "World Stocks (ex USA) Unhedged",
      heading2: "",
    },
    {
      type: "goldETF",
      heading: "Gold ETF",
      heading2: "Gold ETF",
    },
  ];

  var found = builder.find((e) => e.type === key);

  if (found) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: currency === "CAD" ? found.heading : found.heading2,
        }}
      />
    );
    // return currency === 'CAD' ? found.heading : found.heading2;
  }

  return key;
};

const benchmarkOrder = [
  "clientSpecified",
  "cdnStocks",
  "usStocksUnhedged",
  "cdnLongGovtBonds",
  "cdnCash",
  "balancedCdnUnhedgedUsEquity",
  "balancedCdnEquityAndCdnGovtBondsPlusCash",
  "balancedCdnAndUsEquityAndCdnGovtBonds",
  "equalWeight",
];

export const benchmarkSorter = (a, b) =>
  benchmarkOrder.indexOf(a.name) > benchmarkOrder.indexOf(b.name) ? 1 : -1;

export const getDatabaseHeading = (name, currency) => {
  const builder = [
    {
      type: "oneMonthTbillNominalYield",
      heading: "BofC 1-mo Tbill nominal Yield",
      heading2: "1-mo Tbill nominal Yield",
    },
    {
      type: "oneMonthTbillRet",
      heading: "BofC 1-mo Tbill Ret",
      heading2: "1-mo Tbill Ret",
    },
    { type: "closingDate", heading: "Closing Date", heading2: "Closing Date" },
    {
      type: "exchangeRate",
      heading: "FX Rate",
      heading2: "Trade-Weighted USD Index Daily",
    },
    { type: "secondaryIndex", heading: "S&P500 CAD", heading2: "FTSE Return" },
    {
      type: "tenYearBondReturn",
      heading: "10 yr Govt Bond Ret",
      heading2: "10 yr Treasury Bond Ret",
    },
    {
      type: "tenYearGovernmentBondYieldAnnualized",
      heading: "10-YR BM Gov't Bond Yield annualized",
      heading2: "Const 10yr Mat Yield",
    },
    { type: "mainIndex", heading: "TSX Composite", heading2: "S&P500 USD" },
    { type: "vix", heading: "VIX at Date", heading2: "VIX at Date" },
    { type: "ftseWorldCAD", heading: "FTSE World CAD", heading2: "" },
    {
      type: "unemploymentRate",
      heading: "Unemp. Rate",
      heading2: "Unemp. Rate",
    },
    {
      type: "cpiInflation",
      heading: "CPI Inflation",
      heading2: "CPI Inflation",
    },
    {
      type: "goldETF",
      heading: "Gold ETF HUG.TO Return (CAD)",
      heading2: "SPDR Gold Shares (GLD) Return",
    },
    {
      type: "valueReturn",
      heading: "Value  Return",
      heading2: "Value  Return",
    },
    {
      type: "growthReturn",
      heading: "Growth Return",
      heading2: "Growth Return",
    },
  ];

  var found = builder.find((e) => e.type === name);

  if (found) {
    return currency === "CAD" ? found.heading : found.heading2;
  }

  return name;

  // switch (name) {
  //     case 'closingDate':
  //         return 'Closing Date';
  //     case 'mainIndex':
  //         return 'TSX Composite';
  //     case 'secondaryIndex':
  //         return 'S&P500 CAD';
  //     case 'tenYearBondReturn':
  //         return '10 yr Govt Bond Ret';
  //     case 'fx':
  //         return 'FX Rate';
  //     case 'oneMonthTbillRet':
  //         return 'BofC 1-mo Tbill Ret';
  //     case 'oneMonthTbillNominalYield':
  //         return 'BofC 1-mo Tbill nominal Yield';
  //     case 'tenYearGovernmentBondYieldAnnualized':
  //         return '10-YR Govt Bond Yield annualized';
  //     default:
  //         return name;
  // }
};



// WEBPACK FOOTER //
// ./src/helpers/nameHelpers.js